var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 5.8335V8.50016M7.99967 11.1668H8.00634M14.6663 8.50016C14.6663 12.1821 11.6816 15.1668 7.99967 15.1668C4.31778 15.1668 1.33301 12.1821 1.33301 8.50016C1.33301 4.81826 4.31778 1.8335 7.99967 1.8335C11.6816 1.8335 14.6663 4.81826 14.6663 8.50016Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle2);
export default __webpack_public_path__ + "static/media/alert-circle-2.7a430c1d61d8ab601473042f05b62468.svg";
export { ForwardRef as ReactComponent };